import React from "react";
import { useEffect, useState } from "react";
import LoginComponent from "../components/Login";
import axios from "../../../axios";
import { useNavigate, useLoaderData } from "react-router-dom";
import { setAppError } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { printValidationError } from "../../../utils/functions";
import { getDashbaordData } from "../../../store/Api/DashboardData";
import LoadingWithLable from "../../../ReusableComponents/Loading/LoadingWithLable";
import nodeinstance from "../../../nodeInstance";

export default function Login() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(process.env.REACT_APP_BACKEND_URL,"abcdefg");

  const [initialLoading, setInitialLoading] = useState(true);
  const dashboardData = useSelector((state) => state.dashboardData);

  const [loginFormLoading, setLoginFormLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // const loaderData = useLoaderData();

  useEffect(() => {
    if (dashboardData.data && token) {
      navigate("/dashboard");
      setIsAuthenticated(true);
    } else if (token) {
      // dispatch(getDashbaordData(token));

      navigate("/dashboard");
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      setInitialLoading(false);
    }
  }, [token]);

  const submitForm = async (event, email, password, remember) => {
    event.preventDefault();
    setLoginFormLoading(true);
    try {
      const response = await axios.post("/login", { email, password });
      const Noderesponse = await nodeinstance.post("/login",{email, password})
      console.log(response);
      if (response?.status === 200 && Noderesponse?.status === 200) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("nodeToken",Noderesponse.data.token)
        navigate("/dashboard");
      }
      setLoginFormLoading(false);
    } catch (err) {
      setLoginFormLoading(false);
      printValidationError(err, "login");
      dispatch(
        setAppError({
          msg: err.response.data.message,
        })
      );
    }
  };
  return (
    <>
      {initialLoading && <LoadingWithLable />}
      {!isAuthenticated && !initialLoading && (
        <LoginComponent
          submitForm={submitForm}
          setLoginFormLoading={setLoginFormLoading}
          loginFormLoading={loginFormLoading}
        />
      )}
    </>
  );
}

export async function loader() {
  const token = localStorage.getItem("token");
  const NewToken = localStorage.getItem("nodeToken");
  if (token) {
    try {
      const result = await nodeinstance.get("/dashboard/data", {
        headers: { Authorization: `Bearer ${NewToken}` },
      });
      return result;
    } catch (error) {
      localStorage.removeItem("token");
      return { status: 401 };
    }
  } else {
    // redirect("/login");
    return { status: 401 };
  }
}
